module.exports = {
  RU: 'ru',
  ENG: 'eng',
};
